// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"e7c98c72","186":"4f090fbc","357":"380c5bc1","436":"107a1823","488":"6fa17db8","526":"235ec049","549":"3c8f36f9","583":"565fcfe7","747":"c6672a86","952":"ce13a7d6"}[chunkId] + ".chunk.js";
};